
<template>
    <div>
        <mars-view class="case-detail"><top-bar :no-blank="false" title="文章详情" :bg-color="topBar.bgColor" :text-color="topBar.color"></top-bar><mars-view class="article-title">
        {{ articleInfo.title }}
    </mars-view><mars-view v-if="lawyerInfo.name" class="headportraits"><mars-view class="lawyer-content" @click.native="goLawyer"><mars-view class="lawyer-img-box"><mars-image class="lawyer-img" mode="scaleToFill" lazy-load="true" :src="lawyerInfo.personal_avatar"></mars-image><mars-view v-if="lawyerInfo && lawyerInfo.expert_ident" class="lawyer-icon"></mars-view></mars-view><mars-view class="lawyer-main"><mars-view class="lawyer-name">
                    {{ lawyerInfo.name }}律师
                    <lawyer-years style="display: flex;" components-from="case-detail" :lawyer-info="lawyerInfo"></lawyer-years><lawyer-tag style="display: flex;" components-from="case-detail" :lawyer-info="lawyerInfo"></lawyer-tag></mars-view><mars-view class="lawyer-info"><mars-text class="company-name">{{ lawyerInfo.register_law_firm }}</mars-text>{{ lawyerInfo.expertiseArea }}
                </mars-view></mars-view></mars-view></mars-view><mars-view class="artivletext"><bjh-article-text :article="article"></bjh-article-text></mars-view><mars-view class="prompt"><bottom-prompt v-if="prompt" :data="prompt"></bottom-prompt></mars-view><mars-view class="empty-bottombar"></mars-view><lawyer-popup :consult-box="consultBox" :is-vip="isVip && +lawyerInfo.vip_type !== 7 ? '1' : ''"></lawyer-popup></mars-view>
    </div>
</template>

<script>
import bjhArticleText from "../../components/qalandpage/article/bjhArticleText.vue";
import lawyerPopup from "../../components/common/lawyerPopup.vue";
import TopBar from "../../components/common/topbar.vue";
import { getData } from '../../static/utils/request.js';
import { reqPathTo } from '../../static/utils/env.js';
import { formatArticle } from '../../static/utils/bjhFormat.js';
import Prompt from "../../components/common/prompt.vue";
import { act } from '../../static/utils/navigate.js';
import log from '../../static/utils/ubcLog';
import { getConsultInfo } from '../../static/utils/consultEvents.js';
import { setPageInfoMenu } from '../../static/utils/setPageInfoMenu';
import { handleSearch } from '../../static/utils/search';
import lawyerYears from "../../components/lawyer/lawyerYears.vue";
import lawyerTag from "../../components/lawyer/lawyerTag.vue";

/* globals swan, getCurrentPages */
export default {
  components: {
    'lawyer-tag': lawyerTag,
    'lawyer-years': lawyerYears,
    'bjh-article-text': bjhArticleText,
    'bottom-prompt': Prompt,
    'lawyer-popup': lawyerPopup,
    'top-bar': TopBar
  },
  data() {
    return {
      lawyerInfo: {},
      articleInfo: {},
      article: {},
      serviceButton: null,
      prompt: null,
      title: '',
      topBar: {
        title: '',
        color: '#000',
        bgColor: 'custom'
      },
      consultBox: {},
      clientIp: '',
      isVip: '',
      styleType: false,
      qc_no: ''
    };
  },
  methods: {
    init(params) {
      const {
        nid = '9538559500314503652',
        qc_no = '11101200410324002',
        rs_id = '4941'
      } = params;
      this.qc_no = qc_no;
      const getFristDataUrl = reqPathTo('baijiahao/article', {}, '', 'law');
      getData({
        url: getFristDataUrl,
        data: {
          nid,
          qc_no,
          rs_id
        },
        loginNeeded: false
      }).then(data => {
        this.articleInfo = data && data.article;
        this.serviceButton = data && data.service_button;
        this.topBar.title = data && data.title;
        this.prompt = data && data.prompt;
        this.clientIp = data && data.clientIp;
        this.article = data && data.article ? formatArticle(data.article) : {};
        this.setPageInfo(data ? data.article : {}, this.lawyerInfo);
        this.$mpUpdated(() => {
          this.$mp && this.$mp.scope && this.$mp.scope.removeSkeleton && this.$mp.scope.removeSkeleton();
        });
      });
      Promise.all([getConsultInfo(qc_no), getData({
        url: reqPathTo('info', {
          qc_no: this.qc_no
        }, '', 'falv/lawyer'),
        loginNeeded: false
      })]).then(([res1, res2]) => {
        if (res2) {
          this.consultBox = {
            head: res2.stat && res2.stat.service_num,
            img: res2.personal_avatar,
            name: res2.name,
            tail: '人已咨询'
          };
          res2.expertiseArea = res2.domain_list && res2.domain_list.join('、');
          this.lawyerInfo = res2 || {};
          this.isVip = res2.lawyer_tag === '严选' || false;
          this.setPageInfo(this.articleInfo, res2);
        }
        this.consultBox.lawyerServiceNew = res1 && res1.consult_service || {};
      });
    },
    setPageInfo(article, info) {
      if (article && article.title && info && info.name) {
        let content = '';
        if (article.content && article.content.length > 0) {
          article.content.forEach(item => {
            if (content.length > 150) {
              return;
            }
            if (item.type === 'text') {
              content += item.data;
            }
          });
        }
        setPageInfoMenu({
          title: info.name + '律师文章 - ' + article.title + ' - 百度律临',
          keywords: article.title + '、' + info.name,
          description: content
        });
      }
    },
    goLawyer() {
      log.send({
        serverId: 17155,
        area: 'yd_top_lvshi_click',
        action: 'click'
      });
      act({
        target: `/pages/experthome/index?qc_no=${this.qc_no}`,
        type: 'url'
      });
    },
    onPageScroll(e) {
      if (e.scrollTop >= 10 && !this.styleType) {
        this.styleType = true;
        this.topBar.bgColor = '#fff';
      } else if (e.scrollTop < 10 && this.styleType) {
        this.styleType = false;
        this.topBar.bgColor = 'rgba(255, 255, 255, 0)';
      }
    }
  },
  created() {
    (function (ctx) {
      this.init(ctx);
      const fr = ctx.fr;
      const pages = getCurrentPages();
      const page = pages[pages.length - 1] || {};
      let queryStr = '';
      let referrer = '';
      queryStr = page.path || '';
      referrer = document.referrer || 'empty';
      queryStr = queryStr.split('?')[1] || '';
      log.addKey({
        fr: fr || handleSearch(),
        vip: ctx.isVip ? '1' : '',
        page: 'article-detail',
        uri: page.uri,
        queryStr: encodeURIComponent(queryStr),
        referrer: encodeURIComponent(referrer)
      });
      log.send({
        serverId: 17155,
        area: 'all_show',
        action: 'show'
      });
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.case-detail {
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/lawyer-home/case-top-bg.png') no-repeat;
  background-size: 100% 1.62rem;
}
.headportraits {
  margin-top: 4px;
}
.bottombar {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
}
.empty-bottombar {
  height: 65px;
}
.article-title {
  font-family: PingFang SC;
  font-size: 0.21rem;
  color: #1e1f24;
  line-height: 0.32rem;
  padding: 0.12rem 0.17rem;
}
.lawyer-content {
  display: flex;
  align-items: center;
  margin: 0 0.17rem;
}
.lawyer-content .lawyer-img-box {
  width: 0.4rem;
  height: 0.4rem;
  position: relative;
  display: flex;
}
.lawyer-content .lawyer-img-box .lawyer-img {
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background: #d8d8d8;
  border: 0.4px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}
.lawyer-content .lawyer-img-box .lawyer-icon {
  position: absolute;
  bottom: 0;
  right: 0rem;
  width: 0.14rem;
  height: 0.14rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/exporthome/light.png') no-repeat;
  background-size: contain;
}
.lawyer-content .lawyer-main {
  flex: 1;
  padding-left: 0.1rem;
  padding-top: 0.02rem;
  box-sizing: border-box;
}
.lawyer-content .lawyer-main .lawyer-name {
  font-family: PingFang SC;
  font-size: 0.17rem;
  color: #1e1f24;
  letter-spacing: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.lawyer-content .lawyer-main .lawyer-name .lawyer-yanxuan {
  width: 0.46rem;
  height: 0.17rem;
  margin-left: 0.07rem;
  margin-top: -0.015rem;
}
.lawyer-content .lawyer-main .lawyer-name .lawyer-info-years {
  font-family: PingFang SC;
  font-size: 0.13rem;
  color: #848691;
  line-height: 1;
  vertical-align: bottom;
  margin-left: 0.08rem;
}
.lawyer-content .lawyer-main .lawyer-info {
  font-family: PingFang SC;
  font-size: 0.13rem;
  width: 3.3rem;
  color: #848691;
  line-height: 1.15;
  margin-top: 0.08rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lawyer-content .lawyer-main .lawyer-info .lawyer-info-years {
  margin-right: 0.08rem;
}
.lawyer-content .lawyer-main .lawyer-info .company-name {
  margin-right: 0.08rem;
}
.lawyer-content .lawyer-main .lineclamp1 {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.lawyer-content .lawyer-main-not-auth {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
}
.lawyer-content .lawyer-cpc {
  width: 0.78rem;
  height: 0.32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #05f;
  border-radius: 0.18rem;
  font-family: PingFang SC;
  font-size: 0.13rem;
  color: #fff;
  font-weight: 700;
}

</style>
